export default "__VITE_ASSET__DPY4Ifh3__"